import React, {FC, ReactNode} from 'react';

import './styles.scss';

export type PageHeroVariant = 'default' | 'second-brain';

interface IProps {
  color: string;
  img: string;
  title: ReactNode;
  text: ReactNode;
  variant?: PageHeroVariant;
}
const PageHero: FC<IProps> = ({color, img, title, text, variant = 'default'}) => {
  const rootClass = variant === 'second-brain' ? 'page-hero page-hero--second-brain' : 'page-hero';
  const titleStyle = variant === 'second-brain' ? undefined : {backgroundColor: color};

  return (
    <div className={rootClass}>
      <div className="layers-container">
        <div className="layer-1">
          <div className="hero-img d-md-none">
            <img src={img} alt="page-hero" />
          </div>
          <div className="hero-background"></div>
          <div className="hero-img d-none d-md-block">
            <img src={img} alt="page-hero" />
          </div>
        </div>

        <div className="layer-2">
          <div className="header-title" style={titleStyle}>
            <div className="header-title-wrapper">
              <h1>{title}</h1>
              <h2>{text}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHero;
